import {
    useMediaQuery,
    useTheme
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLanguageTransition } from "../../LanguageTransitionContext";
import React from "react";
import JobsectionsCards from "./Jobcards";
import JobsectionsForms from "./Jobforms";


const JobsectionsComponent = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === "ar";
    const { isTransitioning } = useLanguageTransition();

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <section className="job-page-container">
            <div className="container">

                <div className="job-content">
                    <div className="job-content-top">
                        <h3>{t("JobsTitleSectons")}</h3>
                        <p>{t("JobsDescSectons")}</p>
                    </div>
                </div>
                <JobsectionsCards />
                <JobsectionsForms/>
            </div>
        </section>
    );
};

export default JobsectionsComponent;
